// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"07f957d5","383":"78ecd743","752":"f7cb68f4","964":"74658871"}[chunkId] + ".chunk.css";
};